import React, { useEffect, useMemo, useState } from "react";
import { useHistory, useLocation, withRouter } from "react-router-dom";

import { CalendlyView, CalendlyViewProps } from "@Roo/Common/CalendlyView/CalendlyView";
import { UTM_SOURCE_EVENT } from "@Roo/EventSignUp/components/events/common/EventSignUpRedirectContainer";

import { useCalendlyLink } from "../Common/hooks/useCalendlyLink";
import { useRedirect } from "../Common/hooks/useRedirect";
import { useRegistrationContext } from "../Common/registrationContext";
import { RegistrationPageContainer } from "../RegistrationPageContainer/RegistrationPageContainer";

import { useCalendlyViewProps } from "./service";
import { CalendlyContainer } from "./styles";

const RegistrationCalendly = () => {
  const location = useLocation();
  const history = useHistory();
  const searchParams = useMemo(() => new URLSearchParams(location.search), [location.search]);

  const [shiftPreview] = useState(() => {
    const paramValue = searchParams.get("shiftPreview") === "true";
    return paramValue;
  });

  const {
    registrationContext: { email, firstName, lastName, userId, phone, utmSource },
  } = useRegistrationContext();

  useEffect(() => {
    if (shiftPreview) {
      searchParams.delete("shiftPreview");
      history.replace({ search: searchParams.toString() });
    }
  }, [history, searchParams, shiftPreview]);

  const { redirectToMeetRooRep } = useRedirect();

  const { calendlyLink, isLoading } = useCalendlyLink(userId);
  const { onEventScheduled, onDateAndTimeSelected, onEventTypeViewed, onProfilePageViewed } =
    useCalendlyViewProps(shiftPreview);
  const isFromEvent = utmSource === UTM_SOURCE_EVENT;
  const showBackButton = !isFromEvent;

  const goBackRedirect = redirectToMeetRooRep;
  const backButtonTitle = "Back to Roo Rep";

  const calendlyProps: CalendlyViewProps = {
    calendlyLink,
    email,
    name: `${firstName} ${lastName}`,
    phone,
    loading: isLoading,
    onEventScheduled,
    onDateAndTimeSelected,
    onEventTypeViewed,
    onProfilePageViewed,
  };
  const pageTitle = "Get Approved";

  return (
    <RegistrationPageContainer
      title={pageTitle}
      hideProgressBar
      linkProps={
        showBackButton
          ? {
              children: backButtonTitle,
              onClick: goBackRedirect,
            }
          : undefined
      }
    >
      <CalendlyContainer>
        <CalendlyView {...calendlyProps} />
      </CalendlyContainer>
    </RegistrationPageContainer>
  );
};

// eslint-disable-next-line no-restricted-exports
export default withRouter(RegistrationCalendly);
